module.exports = __webpack_public_path__ + "img/phonecall_icon_active.8c2e5c18.svg";